<template>
    <div class="phone-preview">
        <section class="phone-preview-buttons">
            <slot></slot>
        </section>
        <div class="phone-preview-wrapper" v-if="url">
            <div class="phone-preview-window">
                <div class="phone-preview-content">
                    <iframe :src="url" frameborder="0" width="100%" height="100%"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {}
    },
    props: {
        url: {
            type: String,
            required: true
        },
        show: {
            required: false
        }
    },
    methods: {
        close () {
            this.show = false
        }
    }
}
</script>

<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
    .phone-preview{
        display: flex;
        .phone-preview-buttons{

        }
        .phone-preview-window{
            padding: 90px 23px;
            background: url(https://p0.meituan.net/codeman/dd0e82abc55c2db52e81c798f042aedc508284.png) no-repeat;
            background-size: 344px 701px;
        }
        .phone-preview-content {
            width: 298px;
            height: 529px;
        }
    }

</style>



// WEBPACK FOOTER //
// preview.vue?70172cd8